// packages/components/src/admin/users/UserFilterBar.tsx
import React, { useState, useEffect } from 'react';
import { TextField, SelectField, Button, Icon } from '@dopomogai/ui';
// --- FIX: Import the correct, exported type from the UI package ---
import type { DropdownOption } from '@dopomogai/ui'; 
import { useDebounce } from '@dopomogai/agent-kit';

interface UserFilterBarProps {
  onFilterChange: (filters: { searchQuery: string; role: string }) => void;
}

// --- FIX: Use the correct DropdownOption type for the options array ---
const roleOptions: DropdownOption[] = [
  { value: '', label: 'All Roles' },
  { value: 'user', label: 'User' },
  { value: 'platform_admin', label: 'Platform Admin' },
];

export const UserFilterBar: React.FC<UserFilterBarProps> = ({ onFilterChange }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [role, setRole] = useState('');

  const debouncedSearchQuery = useDebounce(searchQuery, 400);

  useEffect(() => {
    onFilterChange({
      searchQuery: debouncedSearchQuery.trim(),
      role,
    });
  }, [debouncedSearchQuery, role, onFilterChange]);

  const handleClearFilters = () => {
    setSearchQuery('');
    setRole('');
  };

  return (
    <div className="p-4 bg-slate-50 border-b border-slate-200 flex items-center gap-4">
      <div className="flex-grow">
        <TextField
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search by name or email..."
          leadingIcon={<Icon name="Search" />}
        />
      </div>
      <div className="w-56">
        <SelectField
          // --- FIX: Add the required 'name' prop ---
          name="role-filter" 
          value={role}
          onChange={(value) => setRole(String(value))}
          options={roleOptions}
        />
      </div>
      <Button
        variant="ghost"
        text="Clear"
        onClick={handleClearFilters}
        disabled={!searchQuery && !role}
      />
    </div>
  );
};